import React from "react";
import { Sakura } from "../ui/Decor";
import { OfferSelector } from "./OfferSelector";
export function FinalCta() {
  return <section id="oferta-final" aria-labelledby="cierre-title" className="relative overflow-hidden bg-pizarra-deep py-14 text-center md:py-20" data-id="element-91" data-mp="3tw904qc47u01">
      <div className="seigaiha pointer-events-none absolute inset-x-0 bottom-0 h-24 opacity-60 invert" aria-hidden="true" data-id="element-92" data-mp="7paqls8x8ohm" />
      <div className="relative mx-auto max-w-3xl px-4 md:px-6" data-id="element-93" data-mp="3g6f8y1d50xn5">
        <Sakura className="mx-auto h-6 w-6 text-sakura" data-id="element-94" data-mp="3b6svprxb7hec" />
        <h2 id="cierre-title" className="mt-4 font-serif text-3xl font-medium leading-tight text-marfil md:text-4xl" data-id="element-95" data-mp="3b8dphfbsuwb5">
          Un camino más claro para estudiar japonés.
        </h2>
        <p className="mt-3 text-crema" data-id="element-96" data-mp="3k5o1x40csrhn">Elegí tu plan y empezá hoy.</p>
        <div className="mx-auto mt-8 max-w-2xl" data-id="element-97" data-mp="2wgv2gxkiw1ia">
          <OfferSelector groupId="final" data-id="element-98" data-mp="2wfjyoxr2utr6" />
        </div>
        <a href="#tabla" className="mt-6 inline-block font-semibold text-marfil underline decoration-dorado underline-offset-4 transition-colors duration-150 hover:text-sakura" data-id="element-99" data-mp="2sf01xvaf1s5k">
          Comparar los tres planes
        </a>
      </div>
    </section>;
}